import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { Text } from '@mantine/core';

const ReadingAsRoutine = () => {
  return <VideoSlide vidSrc={1194418659}></VideoSlide>;
};

export default ReadingAsRoutine;
